import { Amplify } from 'aws-amplify';
import { get } from './configUtility';

Amplify.configure({
	Auth: {
		Cognito: {
			userPoolClientId: get('cognito.userPoolWebClientId'),
			userPoolId: get('cognito.userPoolId')
		}
	}
});
